import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";

import { Link, withRouter } from "react-router-dom";
import { classes } from "../../functions/utils";

// COMPONENTS
import IconAria from "../icons/IconAria";

// REDUX
import { connect } from "react-redux";
import { logout, setUserRole } from "../../actions/userActions";

const UserSection = props => {
  const [userMenuVisible, setUserMenuVisible] = useState(false);

  const handleClickOutside = e => {
    if (userMenuVisible) {
      setUserMenuVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mouseup", handleClickOutside);

    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  });

  const showMenu = () => {
    setUserMenuVisible(true);
  };

  return (
    // <li onClick={() => showMenu("user")} data-test="userBtn" data-menu>
    <span
      onClick={showMenu}
      data-test="userBtn"
      onKeyDown={e => e.key === "Enter" && showMenu()}
      data-menu
      tabIndex="0"
      className="button__nav mainHeaderNav__user"
    >
      <IconAria iconId="user" className="mainHeaderNav__icon mainHeaderNav__user-icon" data-menu />
      <span className="mainHeaderNav__user-name" data-menu></span>
      {/* <span data-menu className="mainHeaderNav__user-arrow">
      <IconAria iconId="arrowDown" data-menu />
    </span> */}
      <ul
        id="userMenu516"
        data-test="userMenuDropdown"
        data-menu
        className={classes(
          "mainHeaderNav__user-menu",
          userMenuVisible ? "" : "mainHeaderNav__user-menu-hide"
        )}
      >
        {props.user && props.user.rights === "admin" && (
          <li>
            <Link
              to="/ui/submission_admin/dashboard"
              data-menu
              className="mainHeaderNav__user-menu-a"
              test="adminLink"
            >
              <IconAria iconId="adminDashboard" />
              <span className="mainHeaderNav__user-menu-text">
                <FormattedMessage id="admin" />
              </span>
            </Link>
          </li>
        )}

        {!props.hideProfile && (
          <li>
            <Link
              to={`/ui/${props.user.role_selected}/profile/edit`}
              data-menu
              className="mainHeaderNav__user-menu-a"
              test="profileLink"
            >
              <IconAria iconId="profile" />
              <span className="mainHeaderNav__user-menu-text">
                <FormattedMessage id="profile" />
              </span>
            </Link>
          </li>
        )}
        {/* <li>
        <Link
          to="/ui/payments"
          data-menu
          className="mainHeaderNav__user-menu-a"
          test="paymentsLink">
          <FaBook/> <span className="mainHeaderNav__user-menu-text"><FormattedMessage id="viewInvoices"/></span>
        </Link>
      </li> */}
        <li>
          <a href="/api/logout" className="mainHeaderNav__user-menu-a">
            <IconAria iconId="logout" />
            <span className="mainHeaderNav__user-menu-text">
              <FormattedMessage id="logout" />
            </span>
          </a>
        </li>
      </ul>
    </span>
    // </li>
  );
};

const mapStateToProps = store => ({
  user: store.user,
});

UserSection.propTypes = {
  hideProfile: PropTypes.bool,
};

export default injectIntl(
  connect(mapStateToProps, { logout, setUserRole })(withRouter(UserSection))
);
